// extracted by mini-css-extract-plugin
export var redoItem = "_g8-1";
export var redoTrigger = "_g8-0";